module.exports = __webpack_public_path__ + "static/media/twitter.df29e40a.svg";